import Home from './pages/public/Home'
import {
  Roles
} from './modules/session'


export default [{
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      role: [Roles.public]
    }
  }, {
    path: '/login',
    name: 'login',
    component: resolve => require(['./pages/public/Login.vue'], resolve),
    meta: {
      role: [Roles.public]
    }
  }, {
    path: '/signup',
    name: 'signup',
    component: resolve => require(['./pages/public/Signup.vue'], resolve),
    meta: {
      role: [Roles.public]
    }
  }, {
    path: '/thankyou',
    name: 'thankyou',
    component: resolve => require(['./pages/public/Thankyou.vue'], resolve),
    meta: {
      role: [Roles.public]
    }
  }, {
    path: '/restrict',
    name: 'restrict',
    component: resolve => require(['./pages/public/restrict.vue'], resolve),
    meta: {
      role: [Roles.public]
    }
  }, {
    path: '/admin/customers',
    name: 'admin.customers',
    component: resolve => require(['./pages/admin/customers.vue'], resolve),
    meta: {
      role: [Roles.admin]
    }
  }, {
    path: '/admin/customer/:custId',
    name: 'admin.customer',
    component: resolve => require(['./pages/customer/account.vue'], resolve),
    meta: {
      role: [Roles.admin]
    }
  }, {
    path: '/admin/users',
    name: 'admin.users',
    component: resolve => require(['./pages/admin/users.vue'], resolve),
    meta: {
      role: [Roles.admin]
    }
  }, {
    path: '/admin/products',
    name: 'admin.products',
    component: resolve => require(['./pages/admin/products.vue'], resolve),
    meta: {
      role: [Roles.admin]
    }
  }, {
    path: '/admin/stock',
    name: 'admin.stock',
    component: resolve => require(['./pages/admin/stock.vue'], resolve),
    meta: {
      role: [Roles.admin]
    }
  }, {
    path: '/admin/invoices',
    name: 'admin.invoices',
    component: resolve => require(['./pages/admin/invoices.vue'], resolve),
    meta: {
      role: [Roles.admin]
    }
  },
  {
    path: '/admin/suppliers',
    name: 'admin.suppliers',
    component: resolve => require(['./pages/admin/suppliers.vue'], resolve),
    meta: {
      role: [Roles.admin]
    }
  },
  {
    path: '/admin/settings',
    name: 'admin.settings',
    component: resolve => require(['./pages/admin/settings.vue'], resolve),
    meta: {
      role: [Roles.admin]
    },
    children: [{
      path: 'company',
      name: 'admin.settings.company',
      component: resolve => require(['./pages/admin/company.vue'], resolve),
      meta: {
        role: [Roles.admin]
      }
    },
      {
      path: 'regions',
      name: 'admin.settings.regions',
      component: resolve => require(['./pages/admin/regions.vue'], resolve),
      meta: {
        role: [Roles.admin]
      }
    },{
      path: 'categories',
      name: 'admin.settings.categories',
      component: resolve => require(['./pages/admin/categories.vue'], resolve),
      meta: {
        role: [Roles.admin]
      }
    }]
  }, 
  {
    path: '/admin/tools',
    name: 'admin.tools',
    component: resolve => require(['./pages/admin/tools.vue'], resolve),
    meta: {
      role: [Roles.admin]
    }
  },
    {
    path: '/customer/dashboard',
    name: 'customer.dashboard',
    component: resolve => require(['./pages/customer/dashboard.vue'], resolve),
    meta: {
      role: [Roles.customer]
    }
  }, {
    path: '/customer/marketplace',
    name: 'customer.marketplace',
    component: resolve => require(['./pages/customer/marketplace.vue'], resolve),
    meta: {
      role: [Roles.customer]
    }
  }, {
    path: '/customer/subscriptions',
    name: 'customer.subscriptions',
    component: resolve => require(['./pages/customer/subscriptions.vue'], resolve),
    meta: {
      role: [Roles.customer]
    }
  }, {
    path: '/customer/requisitions',
    name: 'customer.requisitions',
    component: resolve => require(['./pages/customer/requisitions.vue'], resolve),
    meta: {
      role: [Roles.customer]
    }
  }, {
    path: '/customer/orders',
    name: 'customer.orders',
    component: resolve => require(['./pages/customer/purchaseorder.vue'], resolve),
    meta: {
      role: [Roles.customer]
    }
  },

  {
    path: '/customer/invoices',
    name: 'customer.invoices',
    component: resolve => require(['./pages/customer/invoices.vue'], resolve),
    meta: {
      role: [Roles.customer]
    }
  }, {
    path: '/customer/account',
    name: 'customer.account',
    component: resolve => require(['./pages/customer/account.vue'], resolve),
    meta: {
      role: [Roles.customer]
    }
  },

  /* {
    path: '/courier/shipments',
    name: 'courier.shipments',
    component: resolve => require(['./pages/courier/shipments.vue'], resolve),
    meta: {
      role: [Roles.courier]
    }
  }, {
    path: '/courier/customers/:areaId/area/:areaName',
    name: 'courier.customers',
    component: resolve => require(['./pages/courier/customerlist.vue'], resolve),
    meta: {
      role: [Roles.courier]
    }
  },*/
  {
    path: '/courier/customers',
    name: 'courier.customers',
    component: resolve => require(['./pages/courier/customerlist.vue'], resolve),
    meta: {
      role: [Roles.courier]
    }
  }, {
    path: '/courier/invoices/:custId/company/:companyName',
    name: 'courier.invoices',
    component: resolve => require(['./pages/courier/invoices.vue'], resolve),
    meta: {
      role: [Roles.courier]
    }
  }, {
    path: '/print/invoice/:invId',
    name: 'print.invoice',
    component: resolve => require(['./pages/common/invoice.vue'], resolve),
    meta: {
      role: [Roles.admin, Roles.courier, Roles.customer]
    }
  }, {
    path: '*',
    name: 'notfount',
    component: resolve => require(['./pages/public/notfound.vue'], resolve),
    meta: {
      role: [Roles.public]
    }
  }
]



// WEBPACK FOOTER //
// ./src/routes.js